// extracted by mini-css-extract-plugin
export default {"noResults":"youtube-edit_noResults__eIs1j","deleteButton":"youtube-edit_deleteButton__CE3aG"};